import { render, staticRenderFns } from "./CampaignCreateIntro.vue?vue&type=template&id=1265f727&scoped=true"
import script from "./CampaignCreateIntro.vue?vue&type=script&lang=ts"
export * from "./CampaignCreateIntro.vue?vue&type=script&lang=ts"
import style0 from "./CampaignCreateIntro.vue?vue&type=style&index=0&id=1265f727&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1265f727",
  null
  
)

export default component.exports